import React, { useCallback, useState, useEffect } from "react";

import { A11y } from "@churchofjesuschrist/eden-buttons";
import { Input } from "@churchofjesuschrist/eden-form-parts";
import { Search } from "@churchofjesuschrist/eden-icons";
import {
  textColorSecondary,
  spacing8 as marginTop,
  spacing16 as marginLeft,
} from "@churchofjesuschrist/eden-style-constants";
import styled from "styled-components";

import useManagedStrings from "../../utils/use-managed-strings";
import ClearButton from "../buttons/clear-button/clear-button";

const Holder = styled.div`
  display: flex;
`;
const ButtonHolder = styled.div`
  width: 168px;
  margin-top: ${marginTop};
  margin-left: ${marginLeft};
`;
const stringGroups = [{ name: "shared", keys: ["search"] }];

const defaultFunc = () => {}
const FilterTextInput = ({
  onChange = defaultFunc,
  placeholder,
  clearButton = false,
  inputRef,
  onKeyPress = defaultFunc,
  ...others
}) => {
  const [text, setText] = useState(others.value || "");

  useEffect(() => {
    setText(others?.value || "");
  },[others?.value])
  const changeHandler = useCallback(
    (e) => {
      setText(e.target.value);
      onChange(e.target.value);
    },
    [onChange]
  );

  const clearClick = useCallback(() => {
    setText("");
    onChange("");
  }, [onChange]);
  const { managedStrings: useStrings } = useManagedStrings(stringGroups);
  const usePlaceholder = placeholder ? placeholder : useStrings.search;
  return (
    <Holder>
      <Input
        {...others}
        onKeyPress={onKeyPress}
        onChange={changeHandler}
        type="text"
        ref={inputRef}
        value={text}
        placeholder={usePlaceholder}
        endSlot={(
          <A11y disabled={true}>
            <Search size="24px" color={textColorSecondary} />
          </A11y>
        )}
      />
      {clearButton ? (
        <ButtonHolder>
          <ClearButton onClick={clearClick} />
        </ButtonHolder>
      ) : undefined}
    </Holder>
  );
};

export default FilterTextInput;
